import * as React from 'react';
import SelectCheckbox from './SelectCheckbox';
import { ISelectItem } from '../model';

const styles = require('./styles/SelectItem.css');

function SelectItem(props: ISelectItem) {
	const checkboxRef = React.useRef<HTMLInputElement>(null);

	React.useEffect(() => {
		if (checkboxRef.current) {
			checkboxRef.current.indeterminate = props.indeterminate;
		}
	}, [props.indeterminate]);

	const onItemClick = () => {
		checkboxRef.current && props.onChange && props.onChange(!checkboxRef.current.checked);
	};

	return (
		<li onClick={onItemClick}>
			<div className={styles.selectListContainer}>
				<span className={styles.selectListContent}>{props.value}</span>
				<SelectCheckbox type="checkbox" ref={checkboxRef} checked={props.checked} className={styles.selectListCheckbox} readOnly />
				<span className={props.indeterminate ? styles.indeterminateCheck : styles.checkmark}></span>
			</div>
		</li>
	);
}

export default SelectItem;
